import { LIMIT } from '@constants';

export const RESERVATIONS_PAGE_SIZE = LIMIT;
